import React from 'react';

const Ticks = ({
  field,
  form,
  options,
}) => {
  // Guard: a form may seed this array field to a non-array (e.g. '' from a
  // generic initialValues reducer), and `.filter`/spread would then throw.
  const selected = Array.isArray(field.value) ? field.value : [];

  const handleChange = (option, e) => {
    if (e.target.tagName !== 'INPUT') {
      return;
    }

    const isChecked = selected.includes(option.id);
    const newValue = isChecked ?
      selected.filter(val => val !== option.id) :
      [...selected, option.id];

    form.setFieldValue(field.name, newValue);

    return false;
  };

  return (
    <div className="ticks-field field-group-radio">
      {options.map(option => (
        <div key={option.id} className="tick-item">
          <label onClick={(e) => handleChange(option, e)}>
            <input
              type="checkbox"
              checked={selected.includes(option.id) ? 'checked' : ''}
              value={option.id}
            />
            {option.name}
          </label>
        </div>
      ))}
    </div>
  );
};

export default Ticks;
